import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const playingCardsService = createApi({
  reducerPath: "playingCards",
  baseQuery,
  endpoints: (builder) => ({
    getPlayingCards: builder.query({
      query: () => ({
        url: `/api/users/getcards`,
        method: "GET",
      }),
    }),
  }),
});
export const { useGetPlayingCardsQuery } = playingCardsService;
